// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// var moment = require('moment');
// window.moment = moment

require('datatables.net-bs4');
require('sidebar-menu');
require('admin-script');
require('bootstrap');
require('custom-card');
require('@nathanvda/cocoon');

// Import Chosen for select dropdowns (after jQuery is set globally)
require('chosen-js');
require('chosen-js/chosen.css');

// import { TabulatorFull as Tabulator } from 'tabulator-tables';
// window.Tabulator = Tabulator;


const feather = require("feather-icons");
var ordersTable = null;
var shipmentsTable = null;
var historyTable = null;
var completeOrdersTable = null;
var picklistTable = null;
var productsTable = null;
var invoicesTable = null;

document.addEventListener("turbolinks:load", function () {
  feather.replace();

  if ($("#invoices-table").length) {
    invoicesTable = $("#invoices-table").DataTable({
      "order": [[1, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#system-history").length) {
    // Rows are paged by the server (AdminController#index); DataTables only
    // sorts and searches within the page it was given.
    historyTable = $("#system-history").DataTable({
      "order": [[1, "desc"]],
      "autoWidth": true,
      "paging": false,
      "info": false,
      "language": { "search": "Search this page:" },
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("white-space", "nowrap");
      }
    });
  }

  if ($("#open-orders").length) {
    ordersTable = $("#open-orders").DataTable({
      "order": [[8, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }
  if ($("#sf-orders").length) {
    ordersTable = $("#sf-orders").DataTable({
      "order": [[7, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25,
      "drawCallback": function(settings) {
        $('[data-toggle="popover"]').popover();

        // Calculate sum of RQ amounts for filtered rows
        var api = this.api();
        var total = 0;
        api.rows({ search: 'applied' }).every(function() {
          var rqAmount = parseFloat($(this.node()).data('rq-amount')) || 0;
          total += rqAmount;
        });

        // Format as currency and update footer
        var formatted = '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        $('#rq-amount-total').text(formatted);
      }
    });
    $('[data-toggle="popover"]').popover();
  }

  // Shared by All Purchase Orders and Services / Monitoring. Sorts by Entered
  // (col 7) desc; the Total column carries data-order so currency strings sort
  // numerically rather than as text.
  if ($("#estimates-list").length) {
    $("#estimates-list").DataTable({
      "order": [[8, "desc"]],
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#po-list").length) {
    ordersTable = $("#po-list").DataTable({
      "order": [[7, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "160px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#sf-order-parts").length) {
    ordersTable = $("#sf-order-parts").DataTable({
      "order": [[1, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, 100, 200, -1],
        [10, 25, 50, 100, 200, 'All']
      ],
      "pageLength": 50
    });
  }

  if ($("#shipments-table").length) {
    shipmentsTable = $("#shipments-table").DataTable({
      // "order": [[8, "desc"]],
      // "fnCreatedRow": function( nRow, aData, iDataIndex ) {
      //   $(nRow).children("td").css("overflow", "hidden");
      //   $(nRow).children("td").css("white-space", "nowrap");
      //   $(nRow).children("td").css("text-overflow", "ellipsis");
      //   $(nRow).children("td").css("max-width", "100px");
      // },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#amtec-addresses-table").length) {
    $("#amtec-addresses-table").DataTable({
      "order": [[9, "desc"]],
      "lengthMenu": [
        [25, 50, 100, -1],
        [25, 50, 100, 'All']
      ],
      "pageLength": 50
    });
  }

  if ($("#amtec-shipments-table").length) {
    $("#amtec-shipments-table").DataTable({
      "order": [[0, "desc"]],
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#complete-orders").length) {
    completeOrdersTable = new Tabulator("#complete-orders", {
      layout: "fitColumns",
      pagination: "local",
      paginationSize: 20,
      paginationSizeSelector: [10, 20, 50, 100],
      paginationCounter: "rows",
      movableColumns: true,
      columns: [
        { title: "Order #", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "PO #", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Sales Order #", formatter: "html", sorter: "string", headerFilter: "input" },
        {
          title: "Amount", formatter: "money", formatterParams: {
            decimal: ".",
            thousand: ",",
            symbol: "$",
            symbolAfter: "",
            negativeSign: true,
            precision: 2,
          }, sorter: "string", headerFilter: "input", topCalc: "sum", topCalcFormatter: "money", topCalcFormatterParams: {
            decimal: ".",
            thousand: ",",
            symbol: "$",
            symbolAfter: "",
            negativeSign: true,
            precision: 2,
          }
        },
        { title: "Shipped From", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Requested By", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Account", formatter: "html", sorter: "string", headerFilter: "input" },
        {
          title: "Items", formatter: "html", sorter: "string", headerFilter: "input", topCalc: "sum", topCalcParams: {
            precision: 1,
          }
        },
        { title: "Tracking", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Shipment Type", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Entered On", formatter: "html", sorter: "date", headerFilter: "input" },
        { title: "Shipped On", formatter: "html", sorter: "date", headerFilter: "input" },
        { title: "Required By", formatter: "html", sorter: "date", headerFilter: "input" },

      ]
    });
    $('.download-csv').click(function (event) {
      event.preventDefault();
      completeOrdersTable.download("csv", "exported.csv");
    });
  }

  console.log("Salesforce orders table check");

  if ($("#salesforce-orders").length) {
    console.log("Salesforce orders table found");
    completeOrdersTable = new Tabulator("#salesforce-orders", {
      layout: "fitColumns",
      pagination: "local",
      paginationSize: 20,
      paginationSizeSelector: [10, 20, 50, 100],
      paginationCounter: "rows",
      movableColumns: true,
      columns: [
        { title: "PO Line #", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "SAP Purchase Order", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Vendor", formatter: "html", sorter: "string", headerFilter: "input" },
        {
          title: "Quantity", formatter: "html", sorter: "string", headerFilter: "input", topCalc: "sum", topCalcParams: {
            precision: 1,
          }
        },
        {
          title: "Unit Cost", formatter: "money", formatterParams: {
            decimal: ".",
            thousand: ",",
            symbol: "$",
            symbolAfter: "",
            negativeSign: true,
            precision: 2,
          }, sorter: "string", headerFilter: "input", topCalc: "sum", topCalcFormatter: "money", topCalcFormatterParams: {
            decimal: ".",
            thousand: ",",
            symbol: "$",
            symbolAfter: "",
            negativeSign: true,
            precision: 2,
          }
        },
        { title: "Part Number", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Description", formatter: "html", sorter: "string", headerFilter: "input" },
        { title: "Shipping Location", formatter: "html", sorter: "string", headerFilter: "input" },
      ]
    });

    $('.download-csv').click(function (event) {
      event.preventDefault();
      completeOrdersTable.download("csv", "exported.csv");
    });
  }

  // if ($("#complete-orders").length) {
  //   completeOrdersTable = $("#complete-orders").DataTable({
  //     "order": [[8, "desc"]],
  //     "fnCreatedRow": function (nRow, aData, iDataIndex) {
  //       $(nRow).children("td").css("overflow", "hidden");
  //       $(nRow).children("td").css("white-space", "nowrap");
  //       $(nRow).children("td").css("text-overflow", "ellipsis");
  //       $(nRow).children("td").css("max-width", "100px");
  //     },
  //     "lengthMenu": [
  //       [10, 25, 50, -1],
  //       [10, 25, 50, 'All']
  //     ],
  //     "pageLength": 25
  //   });
  // }

  if ($("#partial-orders").length) {
    completeOrdersTable = $("#partial-orders").DataTable({
      "order": [[8, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#products-list").length) {
    productsTable = $("#products-list").DataTable({
      "order": [[1, "desc"], [2, "desc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  if ($("#pick-list-table").length) {
    picklistTable = $("#pick-list-table").DataTable({
      "order": [[3, "asc"], [4, "asc"]],
      "fnCreatedRow": function (nRow, aData, iDataIndex) {
        $(nRow).children("td").css("overflow", "hidden");
        $(nRow).children("td").css("white-space", "nowrap");
        $(nRow).children("td").css("text-overflow", "ellipsis");
        $(nRow).children("td").css("max-width", "100px");
      },
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      "pageLength": 25
    });
  }

  $(".quantity-shipped").change(function () {
    if ($(this).val() != $(this).data("required")) {
      $(this).addClass("is-invalid");
    }
    else {
      $(this).removeClass("is-invalid");
    }

  });


})

document.addEventListener("turbolinks:before-cache", function () {
  if (ordersTable !== null) {
    ordersTable.destroy();
    ordersTable = null;
  }
  if (shipmentsTable !== null) {
    shipmentsTable.destroy();
    shipmentsTable = null;
  }
  if (completeOrdersTable !== null) {
    completeOrdersTable.destroy();
    completeOrdersTable = null;
  }
  if (picklistTable !== null) {
    picklistTable.destroy();
    picklistTable = null;
  }
  if (productsTable !== null) {
    productsTable.destroy();
    productsTable = null;
  }
  if (historyTable !== null) {
    historyTable.destroy();
    historyTable = null;
  }
  if (invoicesTable !== null) {
    invoicesTable.destroy();
    invoicesTable = null;
  }
});